const icon = require('@/../static/img/onereach-logo-128px.png');
import { UIEventBus, CLICK_NOTIFICATION } from '@/common/ui-event-bus';

export function notifyInBrowser(args: {
  message?: string;
  title?: string;
  params?: object;
}) {
  const DEFAULT_TITLE = 'OneReach';
  const { message = '', title = DEFAULT_TITLE, params = {} } = args;

  const notify = () => {
    if (document.hasFocus()) {
      return;
    }

    const notification = new Notification(title, {
      body: message,
      icon,
    });

    notification.onclick = () => {
      window.focus();
      notification.close();
      UIEventBus.$emit(CLICK_NOTIFICATION, params);
    };
  };

  if (!window.Notification) {
    console.warn('This browser does not support desktop notifications!');
    return;
  }

  if (Notification.permission === 'granted') {
    return notify();
  }

  if (Notification.permission === 'denied') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        notify();
      }
    });
  }
}
